import React, { useEffect, useState } from 'react'
import { Button, Calendar, Col, Dropdown, Menu, Radio, Row } from 'antd'
import images1 from '../../assets/images1.jfif'

import { useSelector } from 'react-redux';
import PersonalInfo from './PersonalInfo';
import ShiftsPlan from './ShiftsPlan';
import { BASE_URL, FetchStaff } from '../../utils/constant';
import { toast } from 'react-toastify';

function CurrentStaff({currentStaffId, onBack}) {
    const [staffcomponent, setStaffcomponents] = useState('personalInfo');
    const [staffDetail, setStaffDetail] = useState([]);
    const [callCurrentStaff, setCallCurrentStaff] = useState(true);
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const handleStaffChange = (data) => {
        console.log('e', data)
        setStaffcomponents(data);
    };

    useEffect(() => {
        getStaffList();
      }, [callCurrentStaff]);
      const getStaffList = async () =>{
        const token = localStorage.getItem('authToken');
        
        try{
         
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({_id : currentStaffId }),
              });
              
              if (response.ok) {
                const data = await response.json();
              console.log('data.data',data.data)
               setStaffDetail(data?.data[0])
              
              } else {
                const data = await response.json();
                console.log('stafferr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }
      const handleBack = () => {
        // navigate("/history");
        onBack();
        const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};

        const stateToSave = {
          attendance:savedState.attendance,
          salesDepartmentId:savedState.salesDepartmentId,
          currentStaffId:savedState.currentStaffId,
          click : savedState.click,
          empClick:savedState.empClick,
          sales:'',
          currentStaff:'' ,
          active:savedState.active ,
        };
        sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
        // window.history.back()
    };
    return (
      <>      
        <div>
         { console.log("========>",staffDetail)}
          <Button className='bg-[#E4EEFC] text-black rounded-md py-1 px-5 h-auto border-none mb-2 !outline-none' onClick={handleBack}>Back</Button>
          <div className='w-100 d-flex mt-3'>
            <div className='w-14 h-14 overflow-hidden rounded-full'>
              <img
                className='w-full h-full object-cover'
                src={staffDetail?.faceRegisterUrl}
                alt=''
              />
            </div>
            <div className='pl-3'>
              <p className='text-xl font-bold'>{capitalizeFirstLetter(staffDetail?.firstName)} {capitalizeFirstLetter(staffDetail?.lastName)} <span className='text-[#AEAEAE]'>({capitalizeFirstLetter(staffDetail?.staffNumber)})</span></p>
              <div className='d-flex text-[19px]'>
                <p className=''>{capitalizeFirstLetter(staffDetail?.designation?.designationName)}</p>
                <p className='ml-3'>{capitalizeFirstLetter(staffDetail?.department?.departmentName)} Department</p>
              </div>
            </div>
          </div>
        </div>
        <div className='flex items-center gap-3 !mt-4'>
          <Button className={`text-[#282F36] border-none rounded-full h-[38px] !text-[13px] min-w-[110px] px-4 !outline-none ${staffcomponent === 'personalInfo' ? 'bg-[#4B8AEB] text-white' : 'bg-[#E4EEFC]'}`} onClick={() => handleStaffChange('personalInfo')} value='personalInfo'>
            Personal Info
          </Button>
          <Button className={`text-[#282F36] border-none rounded-full h-[38px] !text-[13px] min-w-[110px] px-4 !outline-none ${staffcomponent === 'shiftsPlan' ? 'bg-[#4B8AEB] text-white' : 'bg-[#E4EEFC]'}`} onClick={() => handleStaffChange('shiftsPlan')} value='shiftsPlan'>
            Shift Plan
          </Button>
        </div>
          {staffcomponent === 'personalInfo' ? <PersonalInfo staffDetail={staffDetail}  callCurrentStaff={() => setCallCurrentStaff(!callCurrentStaff)}/> : staffcomponent === 'shiftsPlan' ? <ShiftsPlan currentStaffId={currentStaffId}/> : ''}
        </>
      );
}

export default CurrentStaff